<!-- <div class="pagination-footer">
	<div class="showing">
		<span class="showing-text">Showing</span>
	</div>
	<div class="showing-per-page">
		<mat-select [value]="currentPageSize"
			(valueChange)="currentPageSize = $event; showNumberOfRecords(currentPageSize)"
			style="width: 50px; margin-left: 15px">
			<mat-option *ngFor="let val of perPageSize" [value]="val">{{val}}</mat-option>
		</mat-select>
	</div>
	<div class="entries">Entries of {{totalNoOfRows}} Items</div>
	<div class="pagination-controls">
		<pagination-controls (pageChange)="pageIndex = $event; paginate(pageIndex)" [id]="paginationId" previousLabel=""
			nextLabel="" [directionLinks]="true" class="my-pagination"></pagination-controls>
	</div>
</div> -->


<!-- -------------------------old -->
<div class="pagination-footer">
	<div class="page-size displayFlex align-item-center" *ngIf="showPerPageSize">
		<span>Showing</span>
		<span class="page-size-dropdown">
			<mat-select [placeholder]="currentPageSize" [(value)]="currentPageSize" (valueChange)="handlePageSizeClick($event)">
				<mat-option *ngFor="let size of perPageSizes" [value]="size">
					{{size}}
				</mat-option>
			</mat-select>
		</span>
		<span>entries per page</span>
	</div>

	<button class="circle" (click)="goToPreviousPage()"
		[ngClass]="{'non-boundary' : currentPage !== 1,'cursor-not-allowed' : currentPage == 1}"
		[disabled]="currentPage === 1">
		<i class="fa fa-angle-left circle-img"></i>
	</button>

	<ng-container *ngIf="displayPagesArray[0] != 1">
		<button class="page-number" [ngClass]="{'active' : currentPage == 1}" (click)="goToSelectedPage(1)">
			<span class="circle-number">
				1
			</span>
		</button>
		<span *ngIf="displayPagesArray[0] != 2" class="color-9aa7b4 margin-right-8">...</span>
	</ng-container>
	<ng-container *ngFor="let page of displayPagesArray;">
		<button class="page-number" [ngClass]="{'active' : page == currentPage}" (click)="goToSelectedPage(page)">
			<span class="circle-number">{{ page }}</span>
		</button>
	</ng-container>
	<ng-container *ngIf="totalPages > range">
		<ng-container *ngIf="(lastIndex + 1) >= totalPages; else dotsTemplate;">
			<button class="page-number" [ngClass]="{'active' : currentPage === totalPages}"
				(click)="goToSelectedPage(totalPages)">
				<span class="circle-number">{{ totalPages }}</span>
			</button>
		</ng-container>
	</ng-container>

	<button class="circle"
		[ngClass]="{'non-boundary' : currentPage !== totalPages,'cursor-not-allowed' : currentPage === totalPages}"
		[disabled]="currentPage === totalPages" (click)="goToNextPage()">
		<i class="fa fa-angle-right circle-img"></i>
	</button>
</div>

<ng-template #dotsTemplate>
	<span class="color-9aa7b4">...</span>
	<button class="page-number margin-left-8" [ngClass]="{'active' : totalPages == currentPage}"
		(click)="goToSelectedPage(totalPages)">
		<span class="circle-number">
			{{totalPages}}
		</span>
	</button>
</ng-template>